import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"star\">\n    <g clip-path=\"url(#star_clip0_811_12961)\">\n    <path d=\"M10 1.5L12.55 7.20677L18.5 7.99138L14.1258 12.3068L15.253 18.5L10 15.4583L4.747 18.5L5.87423 12.3068L1.5 7.994L7.45 7.20938L10 1.5Z\" fill=\"#CCCCCC\" />\n    </g>\n    <defs>\n    <clipPath id=\"star_clip0_811_12961\">\n    <rect width=\"20\" height=\"20\" fill=\"white\" />\n    </clipPath>\n    </defs>\n    </symbol>"
});
var result = sprite.add(symbol);
export default symbol